<template>
  <div class="overall-bg">
    <b-container>
      <b-row>
        <b-col>
          <BacktoPage path="/ManufacturerMasterTableview"></BacktoPage>
          <Headerlayout
            :headertext="
              EditId
                ? $t('Manufacturer.ManufacturerMaster.EditFormHeader')
                : $t('Manufacturer.ManufacturerMaster.FormHeader')
            "
            :contenttext="
              $t('Manufacturer.ManufacturerMaster.FormHeaderContent')
            "
          >
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="form-white-bg my-3">
        <div>
          <b-form class="px-2" @submit.prevent="IsSubmit">
            <b-row>
              <b-col lg="6" md="6" sm="12" cols="12">
                <b-row>
                  <b-col lg="6" md="6" sm="8" cols="8">
                    <div class="field">
                      <TextField
                        v-model="insert_data.Code"
                        type="text"
                        placeholder=""
                        clearable
                        disabled
                        :label="$t('5006.id')"
                        name="Code"
                        id="Code"
                        :rules="{ required: true }"
                        :required-icon="true"
                      />
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="12" md="12" sm="12" cols="12">
                    <div class="field">
                      <TextField
                        v-model="insert_data.Name"
                        type="text"
                        placeholder=""
                        clearable
                        :label="$t('5006.name')"
                        name="Name"
                        id="Name"
                        :rules="{ required: true }"
                        :required-icon="true"
                        case="Capital"
                        :autofocus="true"
                      />
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="12" md="12" sm="12" cols="12">
                    <AddressDetails v-model="addressdetails" />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="12" md="12" sm="12" cols="12">
                    <div class="field">
                      <TextArea
                        v-model="insert_description.Note"
                        :label="$t('5006.description')"
                        name="Description"
                        id="Description"
                        :rules="{ required: false }"
                      />
                    </div>
                  </b-col>
                  <!-- <b-col lg="6" md="6" sm="6" cols="12" class="mb-4">
                <ContactDetails v-model="insert_contactdetails" />
              </b-col> -->
                </b-row>
                <!-- <b-row class="py-5">
              <b-col lg="12" md="12" sm="12" cols="12">
                <BankInformation v-model="insert_bankdetails" />
              </b-col>
            </b-row> -->
              </b-col>
              <b-col lg="6" md="6" sm="12" cols="12">
                <b-row>
                  <b-col lg="12" md="12" sm="12" cols="12">
                    <FileUpload
                      uploadoption="imageupload"
                      :imageData="imageData"
                      @ImageURL="FileNameData"
                      :PorpsImageList="PorpsImageList"
                      @deletedImageId="deletedImageId"
                    ></FileUpload>
                  </b-col>
                </b-row>
                <div class="pt-5 pe-5 d-flex justify-content-between">
                  <h6 class="compo-heading">
                    {{ $t("5005.contactdetails.contactdetails") }}
                  </h6>
                  <p class="blue-txt" @click="isCreate()">
                    {{ $t("btn.addnew") }}
                  </p>
                </div>
                <b-col xl="12" lg="12" sm="12">
                  <b-row>
                    <b-col
                      xl="12"
                      lg="12"
                      v-for="(items, index) in contactlist"
                      :key="index"
                    >
                      <div>
                        <div class="contactCard">
                          <div class="m-3">
                            <div class="d-flex align-items-center">
                              <span class="light-txt me-4"
                                >{{ $t("5005.contactdetails.contactdetails") }}
                                {{ index + 1 }}</span
                              >
                              <div class="d-flex ms-auto">
                                <div class="blue-txt me-3">
                                  <i
                                    class="pi pi-pencil"
                                    @click="isEditdetails(items, index + 1)"
                                  ></i>
                                </div>
                                <div class="delete">
                                  <i
                                    class="pi pi-trash trash"
                                    @click="contactRemoveTagging(items)"
                                  ></i>
                                </div>
                              </div>
                            </div>
                            <div class="d-flex my-2 align-items-center">
                              <span class="light-txt fn12 me-4"
                                >{{ $t("5005.contactdetails.name") }} :
                              </span>
                              <p class="n-txt">{{ items.ContactPerson }}</p>
                            </div>

                            <div class="d-flex mb-2 align-items-center">
                              <span class="light-txt fn12 me-4"
                                >{{ $t("5005.contactdetails.designation") }} :
                              </span>
                              <p class="n-txt">
                                {{ items.ContactDesignation }}
                              </p>
                            </div>
                            <div class="d-flex mb-2 align-items-center">
                              <span class="light-txt fn12 me-4"
                                >{{ $t("5005.contactdetails.phone") }} :
                              </span>
                              <p class="n-txt">{{ items.Phone }}</p>
                            </div>
                            <div class="d-flex mb-2 align-items-center">
                              <span class="light-txt fn12 me-4"
                                >{{ $t("5005.contactdetails.laneLinenumber") }}
                                :
                              </span>
                              <p class="n-txt">{{ items.LaneLine }}</p>
                            </div>
                            <div class="d-flex mb-2 align-items-center">
                              <span class="light-txt fn12 me-4"
                                >{{ $t("5005.contactdetails.email") }} :
                              </span>
                              <p class="n-txt">{{ items.Email }}</p>
                            </div>
                            <div class="d-flex mb-2 align-items-center">
                              <span class="light-txt fn12 me-4"
                                >{{ $t("5005.contactdetails.fax") }} :
                              </span>
                              <p class="n-txt">{{ items.Fax }}</p>
                            </div>
                            <div class="d-flex mb-2 align-items-center">
                              <span class="light-txt fn12 me-4"
                                >{{ $t("5005.contactdetails.website") }} :
                              </span>
                              <p class="n-txt">{{ items.Web }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <Footer
                  @cancel="clrbtn()"
                  :label="label"
                  :loading="Saveloading"
                />
              </b-col>
            </b-row>
          </b-form>
        </div>
      </b-row>
    </b-container>
    <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
    <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
    <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  </div>
  <contactDetailsMappingPopup
    v-model:trigger="StatusVisible"
    v-if="StatusVisible"
    @update:modelValue="addaddressDetails"
    v-model:selected-item="editItems"
    @close="StatusVisible = false"
  />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  reactive,
  computed,
  onUnmounted,
  watch,
} from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Cancel from "../../../../../../components/GeneralButtons/CancelButtton.vue";
import Save from "../../../../../../components/GeneralButtons/SaveButton.vue";
import AddressDetails from "../../../../../../modules/Inventory/components/MasterCreation/AddressDetails.vue";
import BankInformation from "../../../../../../modules/Inventory/components/MasterCreation/BankInformation.vue";
import FileUpload from "../../../../../../modules/Inventory/components/MasterCreation/FileUpload.vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import service from "../../../../../../modules/Inventory/Service/ManufacturerService";
import ManufactureContactDetailsService from "../../../../Service/ManufactureContactDetailsService";
import { update } from "lodash";

import { useRoute, useRouter } from "vue-router";
import common from "../../../../../../modules/Inventory/Service/CommonService";
import FileUploadService from "../../../../../../modules/Inventory/Service/SupplierMaster";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import TextArea from "../../../../../../components/FormComponents/TextArea.vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import CustomMultiSelect from "../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import contactDetailsMappingPopup from "../../../../../../modules/Inventory/components/MasterCreation/contactDetailsMappingPopup.vue";

export default defineComponent({
  components: {
    contactDetailsMappingPopup,
    CustomMultiSelect,
    AlreadyExist,
    BacktoPage,
    Headerlayout,
    Cancel,
    Save,
    AddressDetails,
    BankInformation,
    FileUpload,
    TextField,
    TextArea,
    Footer,
    CreateSuccessully,
    UpdatedSuccessfully,
    Loader,
  },

  setup(props, { emit }) {
    //Session Hospital&Branch ID
    // const handlePopState = (event) => {
    //   history.pushState(null, document.title, location.href);
    // };
    // const pushInitialState = () => {
    //   history.pushState(null, document.title, location.href);
    // };

    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const route = useRoute();
    const redirectrouter = useRouter();
    const addressRef = ref();
    const UpdateId = route.query;
    const OperationId: any = ref(route.query.OperationId);
    const EditId = route.query.id;
    const successpop = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let Saveloading = ref(false);

    let loading = ref(true);
    let ImageNames;
    let PorpsImageList: any = ref([]);
    let ImageURLList: any = ref([]);
    const StatusVisible = ref(false);
    const editItems = ref();

    watch(
      () => t("btn.save"),
      (newValue) => {
        label.value = newValue;
      }
    );
    const insert_data = ref({
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      Id: 0,
      Code: "",
      Name: "",
      EntityId: 0,
      EntityOperationId: 0,
    });

    const addressdetails = ref({
      SwiftCode: "",
      IecCode: "",
      CdscApproval: ref(),
      TagUnit: ref(),

      StreetName: "",
      Landmark: "",
      Address: "",
      City: ref(),
      State: ref(),
      Country: ref(),
      Pin: "",
    });

    const insert_bankdetails = ref({
      BankName: "",
      BankAcNo: "",
      ReBankAcNo: "",
      BankBranch: "",
      IFSC: "",
    });

    const insert_contactdetails = ref({
      Id: 0,
      ManufactureId: 0,
      ContactPerson: "",
      ContactDesignation: "",
      Phone: "",
      Email: "",
      Web: "",
      LaneLine: "",
      Fax: "",
      index: 0,
    });

    const insert_description = ref({
      Note: "",
    });

    onMounted(async () => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
      //       pushInitialState();
      // pushInitialState();
      //window.addEventListener('popstate', handlePopState);
      init();
    });
    onUnmounted(() => {
      //window.removeEventListener('popstate', handlePopState);
    });
    async function init() {
      debugger;
      console.log(UpdateId.id);
      debugger;
      if (UpdateId.id != undefined) {
        //Row Edit
        try {
          label.value = t("btn.update");
          const EditID = UpdateId.id;
          console.log(EditID);
          try {
            loading.value = true;
            const data_response = await service.Edit(EditID);
            const data1 = data_response["result"];
            console.log(data_response["result"]);

            Object.keys(insert_data.value).forEach((key) => {
              if (data1[key]) insert_data.value[key] = data1[key];
            });

            Object.keys(addressdetails.value).forEach((key) => {
              if (data1[key]) addressdetails.value[key] = data1[key];
            });
            addressdetails.value.TagUnit = data1["TagUnit"]
              .split(",")
              .map(Number);
            addressdetails.value.CdscApproval =
              data1["CdscApproval"] == true ? 1 : 0;

            Object.keys(insert_bankdetails.value).forEach((key) => {
              if (data1[key]) insert_bankdetails.value[key] = data1[key];
            });

            Object.keys(insert_description.value).forEach((key) => {
              if (data1[key]) insert_description.value[key] = data1[key];
            });
            const contactdata_response =
              await ManufactureContactDetailsService.Edit(EditID);
            contactlist.value = contactdata_response["result"];
            const ImgResponse = await service.GetFilesByManufactureId(EditID);
            for (let item of ImgResponse["result"]) {
              PorpsImageList.value.push(item);
            }
            loading.value = false;
          } catch (error) {
            loading.value = false;
            alert(error);
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        GetCode();
      }
    }
    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
        redirectrouter.push({
          path: "/ManufacturerMasterTableview",
        });
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      redirectrouter.push({
        path: "/ManufacturerMasterTableview",
      });
      emit("load");
      IsClear();
    }

    //Clear Input Fields
    const copyinsert_data = JSON.parse(JSON.stringify(insert_data.value));
    const copyaddressdetails = JSON.parse(JSON.stringify(addressdetails.value));
    const copyinsert_bankdetails = JSON.parse(
      JSON.stringify(insert_bankdetails.value)
    );
    const copyinsert_contactdetails = JSON.parse(
      JSON.stringify(insert_contactdetails.value)
    );
    const copyinsert_description = JSON.parse(
      JSON.stringify(insert_description.value)
    );

    function IsClear() {
      Object.assign(insert_data.value, copyinsert_data);
      Object.assign(addressdetails.value, copyaddressdetails);
      Object.assign(insert_bankdetails.value, copyinsert_bankdetails);
      Object.assign(insert_contactdetails.value, copyinsert_contactdetails);
      Object.assign(insert_description.value, copyinsert_description);
      GetCode();
    }
    let updateContact: any = ref([]);
    let createContact: any = ref([]);
    //Save and Update
    const IsSubmit = async () => {
      Saveloading.value = true;
      debugger;
      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      insert_data.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      insert_data.value.ModifiedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );
      insert_data.value.BranchId = BranchId || 0;
      insert_data.value.HospitalId = HospitalId;
      insert_data.value.ModifiedBy = UserId;
      insert_data.value.CreatedBy = UserId;
      insert_data.value.EntityId = Number(Entitydata.value.EntityId);
      insert_data.value.EntityOperationId = Number(OperationId.value);
      addressdetails.value.TagUnit = String(arrtostring.value);
      addressdetails.value.CdscApproval =
        addressdetails.value.CdscApproval == 1 ? true : false;
      let objinsert = Object.assign(
        insert_data.value,
        addressdetails.value,
        insert_bankdetails.value,
        insert_description.value
      );
      console.log(objinsert);
      try {
        let data_response: any;
        let msg = "";
        let contactResult: any;
        const updateid = UpdateId.id;
        let contactResponse: any;
        if (contactlist.length != 0) {
          contactResult = contactlist.value.map(({ index, ...rest }) => rest);

          contactResult.map((item) => {
            (item.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (item.CreatedBy = 0),
              (item.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (item.ModifiedBy = 0),
              (item.HospitalId = HospitalId),
              (item.BranchId = BranchId || 0);
          });
        }
        if (updateid == undefined) {
          const data_response = await service.insert(objinsert);
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          let ManufactureId = data_response["result"];
          if (contactResult.length != 0) {
            contactResult.map((item) => {
              item.ManufactureId = ManufactureId;
            });
            contactResponse = await ManufactureContactDetailsService.insert(
              contactResult
            );
            msg = contactResponse["ErrorInfo"].ErrorCode;
          }
          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            FileInsert(ManufactureId);
            IsClear();
            successpop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else if (updateid != undefined) {
          const data_response = await service.Update(objinsert);
          if (DeletedImageIdArray.value.length > 0) {
            const DeletedImageResponse = await service.DeleteList(
              DeletedImageIdArray.value.join(",")
            );
          }
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          //update
          for (let j = 0; j < contactResult.length; j++) {
            debugger;
            const element = contactResult[j];
            if (element.Id != 0) {
              updateContact.value.push(element);
            } else {
              createContact.value.push(element);
            }
          }
          if (updateContact.value.length != 0) {
            contactResponse = await ManufactureContactDetailsService.Update(
              updateContact.value
            );
            msg = contactResponse["ErrorInfo"].ErrorCode;
          }
          if (createContact.value.length != 0) {
            createContact.value.map((item) => {
              item.ManufactureId = UpdateId.id;
            });
            contactResponse = await ManufactureContactDetailsService.insert(
              createContact.value
            );
            msg = contactResponse["ErrorInfo"].ErrorCode;
          }

          if (removecontact.value.length != 0) {
            for (let i = 0; i < removecontact.value.length; i++) {
              if (!removecontact.value[i].IsActive) {
                let result = await ManufactureContactDetailsService.Delete(
                  removecontact.value[i].id
                );
              }
            }
          }
          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            FileInsert(updateid);
            IsClear();
            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else {
          Saveloading.value = false;
          console.log(updateid);
        }
      } catch (error) {
        Saveloading.value = false;
        alert(error);
      }
    };

    function FileNameData(data) {
      debugger;
      ImageURLList.value = data;
    }
    let DeletedImageIdArray = ref([]);
    function deletedImageId(value) {
      DeletedImageIdArray.value = value;
    }

    const ImgObj = ref({
      CreatedAt: "2023-02-03T11:57:55.028Z",
      ModifiedAt: "2023-02-03T11:57:55.028Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      Id: 0,
      ManufactureId: 0,
      ImageFile: "",
    });

    async function FileInsert(ManufactureId) {
      debugger;
      for (let item of ImageURLList.value) {
        if (!item["Id"]) {
          let Formdata = {
            CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            CreatedBy: UserId,
            ModifiedBy: 0,
            ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            HospitalId: HospitalId,
            BranchId: BranchId,
            Id: 0,
            EntityId: Number(Entitydata.value.EntityId),
            EntityOperationId: Number(OperationId.value),
            ManufactureId: Number(ManufactureId),
            ImageFile: item["ImageFile"].split("/FileUpload/")[1],
          };
          const data_response = await service.Fileinsert(Formdata);
          let msg = data_response["ErrorInfo"].ErrorCode;
        }
      }
    }

    async function clrbtn() {
      const hasNoParams = Object.keys(route.query).length === 0;

      if (hasNoParams) {
        IsClear();
      } else if (UpdateId != undefined) {
        redirectrouter.push({
          name: "ManufacturerMasterTableview",
        });
      }
    }

    //Get Auto generate Code
    async function GetCode() {
      debugger;
      let data = {
        //FormId: 17,
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);
      insert_data.value.Code = result;
    }
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      insert_data.value.Name = "";
      //showDialog.value = true
    }
    const isCreate = () => {
      StatusVisible.value = true;
    };
    function isEditdetails(data, index) {
      try {
        data.index = index;
        editItems.value = data;
        // alert(JSON.stringify(data))

        // Editmodel.value = false;
        debugger;
        StatusVisible.value = true;
      } catch (error) {
        alert(error);
      }
    }
    let contactlist: any = ref([]);
    function addaddressDetails(data) {
      if (data.index == 0) {
        contactlist.value.push(data);
      } else {
        Object.assign(contactlist.value[data.index - 1], data);

        // alert('Update')
      }
      // alert(JSON.stringify(data))
    }
    let removecontact: any = ref([]);
    function contactRemoveTagging(index) {
      const mention = contactlist.value.findIndex((item) => item === index);
      contactlist.value.splice(mention, 1);
      if (index["Id"] != 0) {
        const newObj = {
          id: index["Id"],
        };

        removecontact.value.push(newObj);
        // alert(JSON.stringify(removecontact.value))
      }
    }
    addressdetails;
    const arrtostring = computed(() => {
      if (
        addressdetails.value.TagUnit &&
        addressdetails.value.TagUnit.length > 0
      ) {
        return addressdetails.value.TagUnit.join(", ");
      }
    });
    return {
      arrtostring: arrtostring.value,
      EditId,
      contactRemoveTagging,
      editItems,
      contactlist,
      addaddressDetails,
      isEditdetails,
      isCreate,
      StatusVisible,
      alreadyexistpop,
      insert_data,
      addressdetails,
      insert_bankdetails,
      insert_contactdetails,
      insert_description,
      loading,
      IsSubmit,
      IsClear,
      addressRef,
      GetCode,
      successpop,
      updatepop,
      closetrigger,
      clrbtn,
      FileNameData,
      PorpsImageList,
      imageData: {
        src: "",
        alt: "example image",
      },
      alreadyclosetrigger,
      label,
      Saveloading,
      deletedImageId,
      ImageURLList,
    };
  },
});
</script>
<style lang="scss">
.trash {
  color: red;
}

.contactCard {
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  width: 400px;
  // padding: 20px;

  // .card {

  // }
}

.n-txt {
  font-size: 14px;
  font-weight: 400;

  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}
</style>
